/* eslint-disable no-undef */

import { kf1GetEnvironmentVariables } from "kfone-frontend-core";
import { MODULE_NAME } from "model/constants";

// import { kf1AuthenticatedHttpClient} from 'kfone-component-library';

// (() => {
//   try {
//     env = kf1GetEnvironmentVariables(MODULE_NAME);
//     localStorage.setItem("env Success", JSON.stringify(env));
//   } catch (error) {
//     // env = process.env;
//     localStorage.setItem("env Success", JSON.stringify(error));

//   }
// })();

export const ENV_VARS: Record<string, string> =
  kf1GetEnvironmentVariables(MODULE_NAME);
export const AppEnvVariables: any = {
  ...ENV_VARS,
  API_DOMAIN: ENV_VARS.API_URL.endsWith("/")
    ? ENV_VARS.API_URL.slice(0, -1)
    : ENV_VARS.API_URL,
  SJPR_API_URL: ENV_VARS?.SJPR_API_URL
    ? ENV_VARS.SJPR_API_URL.endsWith("/")
      ? ENV_VARS.SJPR_API_URL.slice(0, -1)
      : ENV_VARS.SJPR_API_URL
    : ENV_VARS.API_URL?.split("/payanalytics")[0] + "/sjpr", // to be updated once 2 env variables available
  KF_TALENT_SUITE: ENV_VARS.KF_TALENT_SUITE,
  SERVICE_URL: ENV_VARS.SERVICE_URL,
  PAY_PGCG_URL: ENV_VARS.PAY_PGCG_URL
};
console.log("AppEnvVariables", AppEnvVariables);
//Sample API call
// const res = await kf1AuthenticatedHttpClient(config);
